import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SessionState } from './sessionState.model';

const initialState: SessionState = {
    sessionId: undefined,
    orderId: undefined,
    externalSessionId: undefined,
    csmMessageId: undefined,
    accessToken: undefined,
    selectedLanguage: undefined,
    refreshTokenUrl: undefined,
    companyId: undefined,
    doctorId: undefined,
    bizContextBase64: undefined,
};

export const sessionSlice = createSlice({
    name: 'session',
    initialState,
    reducers: {
        setSession: (state, action: PayloadAction<SessionState>) => {
            return { ...state, ...action.payload };
        },

        setAccessToken: (state, action: PayloadAction<string>) => {
            return { ...state, accessToken: action.payload };
        },

        setLanguage: (state, action: PayloadAction<string>) => {
            return { ...state, selectedLanguage: action.payload };
        },
    },
});

export const { setSession, setAccessToken, setLanguage } = sessionSlice.actions;
export default sessionSlice.reducer;
